import { useParams, useNavigate } from 'react-router-dom';
import { Layout } from '@/components/layout/Layout';
import { EirsaliyeDetailView } from '@/components/eirsaliye/EirsaliyeDetailView';
import { useEirsaliyeDetail } from '@/hooks/use-eirsaliye';
import { Button } from '@/components/ui/button';
import { ArrowLeft, RefreshCw } from 'lucide-react';

const EIrsaliyeDetail = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { data, isLoading, error } = useEirsaliyeDetail(id);

  return (
    <Layout>
      <div className="p-6 space-y-6">
        {/* Back button */}
        <Button variant="ghost" size="sm" onClick={() => navigate('/eirsaliye')}>
          <ArrowLeft className="w-4 h-4 mr-1" />
          Geri
        </Button>

        {isLoading ? (
          <div className="flex items-center justify-center py-20">
            <RefreshCw className="w-8 h-8 animate-spin text-muted-foreground" />
          </div>
        ) : error ? (
          <div className="text-center py-20 text-destructive">
            <p>Irsaliye yuklenirken hata olustu.</p>
            <p className="text-sm text-muted-foreground mt-1">{(error as Error).message}</p>
          </div>
        ) : data ? (
          <EirsaliyeDetailView data={data} />
        ) : (
          <div className="text-center py-20 text-muted-foreground">
            Irsaliye bulunamadi.
          </div>
        )}
      </div>
    </Layout>
  );
};

export default EIrsaliyeDetail;
